/* MACROUSE */

export interface MacrouseDTO {
    id?: string
    identifier: string
    description: string
    englishDescription: string
    value: number
    clValue: number
}

export interface GetAllMacrouseDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: MacrouseDTO[]
}

export interface MacrouseReviewDTO {
    parcelsByMacrouse : MacrouseReviewDetailsDTO[]
}

export interface MacrouseReviewDetailsDTO {
    macrouseIdentifier :  string
    speciesIdentifier: string
    bioArea: number
    inConversioneArea: number
    convenzionaleArea: number
    naArea: number
}


export interface GetAllMacrouseFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
}

/* SPECIES */

export interface SpeciesDTO {
    id?: string
    identifier: string
    description: string
    englishDescription: string
    icaOrientation: string
    nc8_2013: string
    euCode: string
}

export interface GetAllSpeciesDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: SpeciesDTO[]
}

export interface GetAllSpeciesFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
}

/* VARIETY */

export interface VarietyDTO {
    identifier: string
    description: string
    speciesIdentifier: string
}

export interface GetAllVarietyDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: VarietyDTO[]
}

export interface GetAllVarietyFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
}

/* PARCEL */

export enum MethodEnum {
    NA = 'NA',
    BIOLOGICO = 'BIOLOGICO',
    IN_CONVERSIONE = 'IN_CONVERSIONE',
    CONVENZIONALE = 'CONVENZIONALE'
}

export interface ParcelDTO {
    id: string
    productiveUnitNumber: string
    cadastralCode: string
    section: string
    sub: string
    sheet: string
    parcel: string
    ownership: string
    totalArea: number
    bioArea: number
    conventionalArea: number
    app: string
    macrouseIdentifier: string
    speciesIdentifier: string
    varietyIdentifier: string
    firstNotificationDate: Date
    conversionStartingDate: Date
    conversionEndingDate: Date
    method: MethodEnum
    note: string
    notificationId: string
}

export interface GetAllParcelsDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: ParcelDTO[]
}

export interface GetAllParcelsFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    notificationId?: string
}

/* BULK */

export interface ParcelUpdateDTO {
    conversionStartingDate?: Date
    conversionEndingDate?: Date
    method?: MethodEnum
    note?: string
    parcelId: string
}

export interface ParcelBulkUpdateDTO {
    parcelsBulkUpdateDTO: ParcelUpdateDTO[]
}